import './css/app.css';

import heroWithCta from '~/js/components/hero-with-cta';
import productThumb from '~/js/components/product-thumb';
import colorSelect from '~/js/components/color-select';
import addToCart from '~/js/components/add-to-cart';
import uspHeader from '~/js/components/usp-header';
import header from '~/js/components/header';
import megaMenu from '~/js/components/mega-menu';
import mobileMenu from '~/js/components/mobile-menu';
import tooltip from '~/js/components/tooltip';
import footerAnimation from '~/js/components/footer-animation';
import collectionTemplate from '~/js/components/collection-template';
import faqAccordion from '~/js/components/faq-accordion';
import accordion from '~/js/components/accordion';
import roomleConfigurator from '~/js/components/roomle-configurator';
import contactForm from '~/js/components/contact-form';
import heroFullWidthVideo from '~/js/components/hero-full-width-video';
import price from '~/js/components/price';
import stockInfo from '~/js/components/stock-info';
import emblaSlider from '~/js/components/embla-slider';
import collectionList from '~/js/components/collection-list';
import collectionAllTemplate from '~/js/components/collection-all-template';
import collectionFilters from '~/js/components/collection-filters';
import hotspots from '~/js/components/hotspots';
import cartDrawer from '~/js/components/cart-drawer';
import lighting from '~/js/components/lighting';
import stockErrorModal from '~/js/components/stock-error-modal';
import comingCollections from '~/js/components/coming-collections';
import notifyModal from '~/js/components/notify-modal';

const componentsMap = {
  accordion,
  heroWithCta,
  productThumb,
  colorSelect,
  addToCart,
  uspHeader,
  header,
  megaMenu,
  mobileMenu,
  tooltip,
  footerAnimation,
  collectionTemplate,
  faqAccordion,
  roomleConfigurator,
  contactForm,
  heroFullWidthVideo,
  price,
  stockInfo,
  emblaSlider,
  collectionList,
  collectionAllTemplate,
  collectionFilters,
  hotspots,
  cartDrawer,
  lighting,
  stockErrorModal,
  comingCollections,
  notifyModal,
};

const mountComponents = () => {
  const components = document.querySelectorAll('[data-component]');

  components.forEach((el) => {
    const component = el.dataset.component;

    if (componentsMap[component]) {
      componentsMap[component](el);
    }
  });
};

document.addEventListener('DOMContentLoaded', mountComponents);
document.addEventListener('shopify:section:load', mountComponents);
